import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { HelpCenterSettingsChatConfiguration as main } from '@jira/spa-apps__help-center-settings-chat-configuration/src/HelpCenterSettingsChatConfiguration.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsChatConfigurationRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsChatConfigurationRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

const HelpCenterSettingsChatConfigurationEntryPoint: ReturnType<typeof createPageEntryPoint> =
	createPageEntryPoint({
		main,
	});

export const helpCenterSettingsChatConfigurationRouteEntry: Route = createEntry(
	helpCenterSettingsChatConfigurationRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.chat-configuration',
		layout: globalLayout,
		navigation: { menuId: MenuIdCustomerExperiences },
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint() {
			return fg('csm-omni-channel-live-chat-in-widget')
				? HelpCenterSettingsChatConfigurationEntryPoint
				: undefined;
		},
		resources: [...getServiceDeskSettingsResources(), customerExperiencesNavigationResource],
		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName:
					'@jira/router-routes__help-center-settings-entries/src/helpCenterSettingsChatConfigurationRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsChatConfigurationRouteEntry',
			},
			enabled: true,
		},
	}),
);
